import React,{useState} from 'react'
import Canvas from "../canvas/Canvas"

import thumb26 from '../images/thumb_26.jpg';
import thumb27 from '../images/thumb_27.jpg';
import thumb28 from '../images/thumb_28.jpg';
import thumb29 from '../images/thumb_29.jpg';

import img26 from '../images/26.png';
import img27 from '../images/27.png';
import img28 from '../images/28.png';
import img29 from '../images/29.png';

import {Modal} from 'react-bootstrap';
import "./modal.css";


export default function Retina(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Lids");
    const [showImage,setShowImage] = useState(img26);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }
    return(
        <>
           <div className="card card-custom gutter-b">
                <div className="card-header">
                    <div className="card-title">
                        <h3 className="card-lable">
                            Retina
                        </h3>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">

                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb26}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">ARMD Dry</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Retina - AMD Dry",img26)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb27}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">AMD Wet</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Retina - AMD Wet",img27)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb28}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Diabetic Retinopathy</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Retina - Diabetic Retinopathy", img28)}>Draw</button>
                                 
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb29}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Detachment</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Retina Detachment",img29)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        



                    </div>
                </div>
            </div>  
            <Modal
                show={show}
                size="lg"
                onHide={()=>setShow(false)}
                dialogClassName="modal-90w"
                >
                    <Modal.Header closeButton>
                      
                        <Modal.Title>
                            Eye Draw - {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>     
                      {/*   <Image src={img1} fluid />*/}
                      <div style={{height:"70vh",width:"60vw"}}>
                      <Canvas image={showImage} />
                      </div>
                     
                    </Modal.Body>
                </Modal>           
        </>
    )
}